import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL, sharePopupImage } from '@images/imageUrls';
import classNames from 'classnames';
import Toast from '@components/Toast';
import { copy } from '@utils/copy';

interface H5CommonSharePopupProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    // 是否显示
    visible: boolean;
    // 显示隐藏
    shareClose?: Function
    // 标题
    title?: string;
    // 取消事件
    onCancelChange?: Function
    // 取消按钮文字
    cancelText?: string
    // 插槽相关属性
    children?: React.ReactNode; // 内容插槽
    mode?: any  // 模式（黑色或白色,默认白色）
    copyText?: any  // 要复制的文本
    copyLink?: Function // 复制链接方法
    onDrawCanvas?: Function // 保存图片方法
    isShowCopy?: any    // 是否显示复制链接
    isShowSavePoster?: any    // 是否显示保存图片
    copyToastText?: any // 复制后的提示语
}

@inject('app', 'site', 'user')
@observer
class H5CommonSharePopup extends React.Component<H5CommonSharePopupProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }
    // 隐藏
    onHidePopup = () => {
        this.props.onCancelChange && this.props.onCancelChange()
    }
    // 复制链接
    copyLinkClick = () => {
        let { copyText, copyToastText } = this.props;
        copy(copyText);
        Toast.success({ content: copyToastText ? copyToastText : '复制成功' });
        this.props.copyLink && this.props.copyLink()
    }

    render() {
        let {  visible, title, isShowCopy = true, isShowSavePoster = false, cancelText = '取消', children, mode } = this.props
        console.log(visible, '是否打开')
        return <>
            <div className={classNames(styles.popupBox, visible ? styles.openPopup : '')}>
                <div className={classNames(styles.popupMask)} onClick={this.onHidePopup}></div>
                <div className={classNames(styles.sharePopupContent, mode == 'black' ? styles.sharePopupContentBlack : '')}>
                    <div className={styles.shareGap}></div>
                    <div className={styles.shareTitle}>{title != '' ? title : '分享'}</div>
                    <div className={styles.shareContent}>
                        {/* <div className={styles.shareItem}>
                            <img className={styles.shareIcon} src="https://bbsfiles.iqoo.com/icon/20250210/WeChat.png" />
                            <div className={styles.shareText}>微信</div>
                        </div>
                        <div className={styles.shareItem}>
                            <img className={styles.shareIcon} src="https://bbsfiles.iqoo.com/icon/20250210/circle-friends.png" />
                            <div className={styles.shareText}>朋友圈</div>
                        </div> */}
                        {isShowCopy && <div className={styles.shareItem} onClick={() => this.copyLinkClick()}>
                            <img className={styles.shareIcon} src={mode == 'black' ? `${BASE_IMG_URL}/common/copy2.png` : `${BASE_IMG_URL}/common/copy2.png`} />
                            <div className={styles.shareText}>复制链接</div>
                        </div>}
                        {isShowSavePoster && <div className={styles.shareItem} onClick={() => {
                            this.props.onDrawCanvas && this.props.onDrawCanvas()
                        }}>
                            <img className={styles.shareIcon} src={mode == 'black' ? sharePopupImage.saveDark : sharePopupImage.saveLight} />
                            <div className={styles.shareText}>保存图片</div>
                        </div>}
                    </div>
                    <div className={classNames(styles.shareCancel, mode == 'black' ? styles.shareCancelBlack : '')} onClick={() => { this.onHidePopup && this.onHidePopup() }}>{cancelText}</div>
                </div>
            </div>
        </>;
        
    }
}

export default H5CommonSharePopup;